import React from 'react';
import Hero from '../../components/pages/Platforms/Hero/Hero';
import DID from '../../components/pages/Platforms/DID/DID';
import Engineered from '../../components/pages/Platforms/Engineered/Engineered';
import MetaTrader from '../../components/pages/Platforms/MetaTrader/MetaTrader';
import EntryPoints from '../../components/pages/Platforms/EntryPoints/EntryPoints';
import Awaits from '../../components/pages/Platforms/Awaits/Awaits';

const Platforms = () => {
  return (
    <div>
      <Hero />
      <DID />
      <Engineered />
      <MetaTrader />
      <EntryPoints />
      <Awaits />
    </div>
  );
};

export default Platforms;
